import React from 'react';
import cn from 'classnames';
import { useEditorContainerSize } from '@wix/da-editor-tiptap/pkg/components/Editor/Context';
import LitView from '../../../DeviationViews/Dumbo/Literature';
import { Props } from '../MonoView';
import EditorDeviationLink from '../_partials/DeviationLink';
import { useFreeformSquareSizing } from '../helpers';

import s from './Literature.scss';

const JournalView: React.FC<Props> = props => {
  const containerSize = useEditorContainerSize();
  const { deviation, extOptions, width: propsWidth, link } = props;
  const size = useFreeformSquareSizing(propsWidth, extOptions, containerSize);

  return (
    <div className={cn(s['root'])} style={{ width: size.width }}>
      <EditorDeviationLink link={link} deviation={deviation}>
        <LitView
          width={size.width}
          height={size.height}
          deviation={deviation}
        />
      </EditorDeviationLink>
    </div>
  );
};
JournalView.displayName = 'JournalView';

export default JournalView;
